/* eslint-disable array-callback-return */
import { API_POSITION } from "../constants/api";

const getBaseUrl = (currentPage, pageSize, sortOrderList) => {
  const sortList = [];
  let sort = "";
  for (const key in sortOrderList) {
    if (sortOrderList[key] === 1) {
      sortList.push(`${key}_asc`);
    }
    if (sortOrderList[key] === -1) {
      sortList.push(`${key}_desc`);
    }
  }
  if (sortList.length !== 0) {
    sort = sortList.join(",");
  }
  if (sort !== "") {
    return `${API_POSITION}?page=${currentPage}&per_page=${pageSize}&sort=${sort}`;
  }
  return `${API_POSITION}?page=${currentPage}&per_page=${pageSize}`;
};

const formatPositionData = (positionsData) => {
  const updatePositionsData = positionsData.map((position) => {
    const updatePermissionsData = position.permissions.reduce(
      (acc, permission) => {
        acc[permission.feature.code] = permission.access_level;
        return acc;
      },
      {}
    );
    return {
      ...position,
      delete: false,
      permissions: updatePermissionsData,
    };
  });
  return updatePositionsData;
};

const formatFeatures = (features) => {
  const newFeatures = {};
  features.map((item) => {
    newFeatures[item.code] = item.name;
  });
  return newFeatures;
};

export { getBaseUrl, formatPositionData, formatFeatures };
